<template>
  <div
    class="notification"
    :class="'notification--info'"
    v-if="showNotification"
  >
    <div class="notification__dismiss" @click="onDismiss">
      <fa icon="times" />
    </div>
    <div class="notification__icon">
      <fa icon="info-circle" />
    </div>
    <div class="notification__content">
      <div class="notification__title">{{ $t('experimentalMsg.title') }}</div>
      <div class="notification__body">
        {{ $t('experimentalMsg.body') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showNotification: true,
    };
  },
  methods: {
    onDismiss() {
      this.showNotification = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.notification {
  display: flex;
  border: 3px solid;
  padding: 20px;
  margin-bottom: 15px;
  position: relative;
  margin: 10px 0;

  &__dismiss {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }

  &__icon {
    margin-right: 10px;
  }

  &__title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  &__body {
    p {
      margin-bottom: 5px;
    }
  }

  &--info {
    border-color: #8a4e94;
    .notification__icon {
      color: #8a4e94;
    }
  }
}
</style>
